import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

export default function BlogSection() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBlogs = async () => {
            setLoading(true);
            try {
                const res = await axios.get("https://beachhotelsdubai.com/api/blogs");
                const data = res.data;
                setBlogs(data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">

            {/* Header */}
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">

                <div>
                    <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-100 text-[#0F172A] text-sm font-semibold mb-4">
                        Travel Guides & Tips
                    </span>

                    <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
                        Latest Travel Blogs
                    </h2>

                    <p className="text-slate-500 mt-3 max-w-2xl">
                        Discover travel inspiration, hotel guides, Dubai attractions,
                        money-saving tips and expert recommendations.
                    </p>
                </div>

                <button
                    onClick={() => navigate("/blogs")}
                    className="hidden sm:flex items-center gap-2 px-6 py-3 bg-[#0F172A] text-white rounded-xl hover:bg-orange-600 transition"
                >
                    View All Articles →
                </button>

            </div>

            {/* Loader */}
            {loading ? (
                <div className="flex flex-col justify-center items-center py-20 gap-4">
                    <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#0F172A] border-t-transparent"></div>
                    <p className="text-slate-500">Loading blogs...</p>
                </div>
            ) : blogs.length > 0 ? (
                <>
                    {/* Blogs Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                        {blogs.slice(0, 3).map((blog) => (
                            <div
                                key={blog.id}
                                className="group bg-white rounded-[28px] overflow-hidden border border-orange-100  shadow-lg hover:shadow-[0_15px_40px_rgba(255,107,53,0.15)] hover:-translate-y-2 transition-all duration-500"
                            >

                                {/* Image */}
                                <Link to={`/blogs/${blog.slug}`}>
                                    <div className="relative h-[250px] overflow-hidden">

                                        <img
                                            src={blog.thumbnail_image}
                                            alt={blog.title}
                                            className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                                        />

                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>

                                        {/* Category */}
                                        <span className="absolute top-4 left-4 bg-white text-[#0F172A] px-4 py-2 rounded-full text-xs font-semibold shadow-lg">
                                            {blog.category?.name}
                                        </span>

                                    </div>
                                </Link>

                                {/* Content */}
                                <div className="p-6">

                                    <p className="text-xs text-slate-400 mb-3">
                                        {new Date(blog.created_at).toDateString()}
                                    </p>

                                    <Link to={`/blogs/${blog.slug}`}>
                                        <h3 className="text-xl font-bold text-slate-900 line-clamp-2 group-hover:text-[#0F172A] transition">
                                            {blog.title}
                                        </h3>
                                    </Link>

                                    <p className="text-slate-500 mt-4 line-clamp-3 leading-6 min-h-[72px]">
                                        {blog.excerpt}
                                    </p>

                                    <Link
                                        to={`/blogs/${blog.slug}`}
                                        className="mt-6 inline-flex items-center gap-2 text-[#0F172A] font-semibold hover:gap-3 transition-all"
                                    >
                                        Read Article →
                                    </Link>

                                </div>

                            </div>
                        ))}

                    </div>

                    {/* ✅ MOBILE BUTTON (BOTTOM ONLY) */}
                    <div className="mt-10 sm:hidden">
                        <button
                            onClick={() => navigate("/blogs")}
                            className="w-full bg-[#0F172A] text-white px-5 py-3 rounded-xl hover:bg-orange-600 transition font-medium"
                        >
                            View All Articles
                        </button>
                    </div>
                </>
            ) : (
                <p className="text-gray-500">No blogs found</p>
            )}
        </section>
    );
}